import { IConfigurableFieldDataTypes } from '@shared/interfaces';

export const isNonEmpty = (value: IConfigurableFieldDataTypes) =>
  value !== null && value !== undefined && value.toString().trim().length > 0;
